import React, { useMemo } from 'react';
import { formatDate } from 'date-fns';
import {
  SubmissionResponseDto,
  SubmissionResponseDtoStatusEnum,
} from 'libs/pinnacle-sdk';
import FlagIcon from 'assets/icons/flag';
import userImg from 'assets/images/user.png';

const SubmissionCard: React.FC<SubmissionResponseDto> = (submission) => {
  const cardStyle = useMemo(() => {
    switch (submission.status) {
      case SubmissionResponseDtoStatusEnum.Prospect:
        return {
          primaryColor: '#16ABDB',
        };

      case SubmissionResponseDtoStatusEnum.Pending:
        return {
          primaryColor: '#E48F00',
        };

      case SubmissionResponseDtoStatusEnum.Quoted:
        return {
          primaryColor: '#8F37F5',
        };

      case SubmissionResponseDtoStatusEnum.Complete:
        return {
          primaryColor: '#329B57',
        };
      default:
        return {
          primaryColor: '#16ABDB',
        };
    }
  }, [submission.status]);

  // TODO: Add logic to determine the flag color based on types
  const flagStyle = useMemo(() => {
    return {
      primaryColor: '#0FC34F',
      secondaryColor: '#D6EBDD',
    };
  }, []);

  return (
    <div>
      <div
        className="flex-1 shadow-[0px_4px_24px_rgba(0,_0,_0,_0.08)] rounded-t-[6px] rounded-b-[12px] bg-white border-t-[2px] border-solid box-border overflow-hidden flex flex-col items-end justify-start pt-[13px] px-[12px] pb-[16px] gap-[16px] min-w-[107px] cursor-pointer text-right text-[12px] text-[#1D67B6]"
        style={{ borderColor: cardStyle.primaryColor }}
      >
        <div className="self-stretch flex flex-col items-start justify-start gap-[12px] text-[9px]">
          <div className="flex flex-row items-start justify-start gap-[4px]">
            <div className="flex-1 rounded-[6px] bg-[#C1DFFF] overflow-hidden flex flex-row items-start justify-start py-[4px] pl-[6px] pr-[5px]">
              <div className="flex-1 relative leading-[140%] font-medium inline-block min-w-[20px]">
                {submission.transactionType}
              </div>
            </div>
            <div
              className="rounded-[6px] overflow-hidden flex flex-row items-center justify-start py-[4.5px] px-[6px]"
              style={{ backgroundColor: flagStyle.secondaryColor }}
            >
              <FlagIcon color={flagStyle.primaryColor} />
            </div>
          </div>
          <div className="rounded-[6px] [background:linear-gradient(180deg,_rgba(254,_187,_139,_0.2),_rgba(255,_159,_92,_0.2))] overflow-hidden hidden flex-row items-start justify-start py-[7px] px-[12px] text-[14px] text-[#ffa260]">
            <div className="flex flex-row items-center justify-start">
              <div className="relative leading-[140%] font-medium">Finance</div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-[4px] text-left text-[12px] text-[#010D1D]">
            <div className="self-stretch relative leading-[140%] font-medium">
              {submission.insured?.name}
            </div>
            <div className="self-stretch relative leading-[140%] text-[#5E6B7C]">
              hard-coded@underwriter.com
            </div>
          </div>
        </div>
        <div className="self-stretch h-[1px] relative border-[#E4E4E4] border-t-[1px] border-solid box-border" />
        <div className="self-stretch relative leading-[140%] text-[#5E6B7C] text-left">
          {submission.lineOfBusiness}
        </div>
        <div className="self-stretch h-[1px] relative border-[#E4E4E4] border-t-[1px] border-solid box-border" />
        <div className="self-stretch flex flex-row items-center justify-between gap-[20px] text-[#010D1D]">
          <div className="flex flex-row items-start justify-start">
            <img
              className="rounded-xl border-white border-[2px] h-[24px] w-[24px] relative object-cover"
              alt="Underwriter"
              src={userImg}
            />
            <img
              className="rounded-xl border-white border-[2px] h-[24px] w-[24px] relative object-cover z-[1] ml-[-8px]"
              alt="Underwriter"
              src={userImg}
            />
          </div>
          <div className="relative leading-[140%] font-medium inline-block min-w-[83px]">
            {formatDate(submission.inceptionDate, 'MMM dd, yyyy')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionCard;
